import * as ReactHighcharts from "react-highcharts";
import {
  IFilter,
  round,
  IVisualizationState,
  IPeerGroupTabsProps,
  roundNumber,
} from "../../lib/http";
import * as React from "react";
import { Panel } from "react-bootstrap";
import PanelGraph from "app/components/tabs/PanelGraph";

export class AssetAllocationCashFixed extends React.Component<
  IPeerGroupTabsProps,
  IVisualizationState
  > {
  state: IVisualizationState = {
    categories: [],
    data: [],
    series: [],
    filters: { assetLevel: -1 },
    title: "",
    loading: false,
    average: [],
    plotLineNumber: 0,
  };

  componentDidMount() {
    this.setState({ data: this.props.data }, () =>
      this.loadSeries(this.props.filters)
    );
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.filters.assetLevel !== this.props.filters.assetLevel ||
      prevProps.data.length !== this.props.data.length
    ) {
      this.setState(
        { filters: this.props.filters, data: this.props.data },
        () => {
          this.loadSeries(this.props.filters);
        }
      );
    }
  }

  loadSeries(filters: IFilter) {
    const { data } = this.state;

    const currentSet = data.find(
      (dataPoint) => dataPoint.filterId === filters.assetLevel
    );

    const filterOutAllFoundations = data.filter(
      (dataPoint) => dataPoint.filterId > 0
    );
    const filterOutAllFoundationsSize = filterOutAllFoundations.length;

    const categories = filterOutAllFoundations.map(
      (dataPoint) => dataPoint["Strat_T_V20_Col"]
    );

    const selectedLightColor = "#8EA9DB";
    const selectedDarkColor = "#305496";
    const nonselectedLightColor = "#D9E1F2";
    const nonselectedDarkColor = "#B4C6E7";

    const cashData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
            y: roundNumber(dataPoint["Strat_N_V20_AllocCash"] * 100.0, 1),
            color: selectedLightColor,
          }
        : {
            y: roundNumber(dataPoint["Strat_N_V20_AllocCash"] * 100.0, 1),
            color: nonselectedLightColor,
          }
    );

    const fixedData = filterOutAllFoundations.map((dataPoint) =>
      dataPoint.filterId === filters.assetLevel
        ? {
            y: roundNumber(dataPoint["Strat_N_V20_AllocFixed"] * 100.0, 1),
            color: selectedDarkColor,
          }
        : {
            y: roundNumber(dataPoint["Strat_N_V20_AllocFixed"] * 100.0, 1),
            color: nonselectedDarkColor,
          }
    );

    const title = currentSet ? currentSet["Strat_T_V20_Vis20Title"] : "";

    const averageData = filterOutAllFoundations.map((dataPoint, index) => {
      const y = parseFloat(
        round(dataPoint.Strat_N_V20_AvgAllocCashandFixed * 100.0, 1)
      );
      return index === filterOutAllFoundationsSize - 1
        ? { y: y, dataLabels: { enabled: true, format: "Average: {y}%" } }
        : y;
    });

    const plotLineNumber = currentSet
      ? parseFloat(
        round(currentSet["Strat_N_V20_AvgAllocCashandFixed"] * 100.0, 1)
      )
      : 0;

    const series = [
      { color: "#8497B0", name: "Fixed Income", data: fixedData },
      { color: "#ACB9CA", name: "Cash", data: cashData },
      {
        color: "#a1a1a1",
        name: "Average",
        data: averageData,
        type: "line",
        dashStyle: "ShortDash",
        lineWidth: 3,
        marker: { enabled: false },
        showInLegend: false,
      },
    ];

    this.setState({ title, series, categories, plotLineNumber });
  }

  updateFilter(e) {
    if (this.props.onChangeFilterId) {
      this.props.onChangeFilterId(e.point.filterId);
    }
  }

  static getChartConfig(title, series, categories) {
    return {
      chart: { type: "column" },
      title: {
        text: title,
      },
      xAxis: {
        categories,
      },
      yAxis: {
        visible: true,
        opposite: true,
        title: "",
        labels: {
          format: "{value}%",
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: true,
            format: "{y:.1f}%",
          },
        },
      },
      legend: { enabled: true },
      credits: { enabled: false },
      series,
    };
  }

  render() {
    const { title, loading, series, categories } = this.state;
    return (
      <PanelGraph
        title=""
        loading={loading}
        chartConfig={AssetAllocationCashFixed.getChartConfig(
          title,
          series,
          categories
        )}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/visualizations/PeerGroups/AssetAllocation/AssetAllocationCashFixed/index.tsx